module.exports = __webpack_public_path__ + "img/cosplay.13961d05.jpg";